import {Accordion, AccordionSummary, styled} from '@mui/material';

const StyledAccordion = styled(Accordion)`
	&.MuiAccordion-root {
		box-shadow: none;
		border-top: 0px;

		::before {
			background-color: transparent;
		}

		border-radius: 8px;
	}

	&.Mui-expanded {
		margin: 16px 0px 0px;
	}
`;

const StyledAccordionSummary = styled(AccordionSummary)`
	&.MuiAccordionSummary-root {
		border-top: 0px;
	}

	.MuiAccordionSummary-content {
		margin: 0px;
		padding: 16px 0;
	}
`;

export {StyledAccordion, StyledAccordionSummary};
